/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Step3_TitleInputs */

const en_keyword_optimizer_step3_title = /** @type {(inputs: Keyword_Optimizer_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const de_keyword_optimizer_step3_title = /** @type {(inputs: Keyword_Optimizer_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwenden`)
};

const fr_keyword_optimizer_step3_title = /** @type {(inputs: Keyword_Optimizer_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer`)
};

const es_keyword_optimizer_step3_title = /** @type {(inputs: Keyword_Optimizer_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar`)
};

const it_keyword_optimizer_step3_title = /** @type {(inputs: Keyword_Optimizer_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica`)
};

const nl_keyword_optimizer_step3_title = /** @type {(inputs: Keyword_Optimizer_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toepassen`)
};

const pl_keyword_optimizer_step3_title = /** @type {(inputs: Keyword_Optimizer_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zastosuj`)
};

const fi_keyword_optimizer_step3_title = /** @type {(inputs: Keyword_Optimizer_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovella`)
};

const da_keyword_optimizer_step3_title = /** @type {(inputs: Keyword_Optimizer_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anvend`)
};

const sv_keyword_optimizer_step3_title = /** @type {(inputs: Keyword_Optimizer_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillämpa`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Keyword_Optimizer_Step3_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_step3_title = /** @type {((inputs?: Keyword_Optimizer_Step3_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Step3_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_step3_title(inputs)
	if (locale === "fr") return fr_keyword_optimizer_step3_title(inputs)
	if (locale === "es") return es_keyword_optimizer_step3_title(inputs)
	if (locale === "it") return it_keyword_optimizer_step3_title(inputs)
	if (locale === "nl") return nl_keyword_optimizer_step3_title(inputs)
	if (locale === "pl") return pl_keyword_optimizer_step3_title(inputs)
	if (locale === "fi") return fi_keyword_optimizer_step3_title(inputs)
	if (locale === "da") return da_keyword_optimizer_step3_title(inputs)
	if (locale === "sv") return sv_keyword_optimizer_step3_title(inputs)
	return en_keyword_optimizer_step3_title(inputs)
});